import type { RxJsonSchema } from 'rxdb';
import type { Notification } from './notification.types';

export const notificationSchema: RxJsonSchema<Notification> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'pkUSerAlertId',
  properties: {
    pkUSerAlertId: { type: 'string', maxLength: 36 },
    alertNotificationId: { type: ['number', 'null'] },
    userId: { type: ['number', 'null'] },
    alertText: { type: ['string', 'null'] },
    isRead: { type: ['boolean', 'null'] },
    isMobileAlert: { type: ['boolean', 'null'] },
    createdBy: { type: ['string', 'null'] },
    firstName: { type: ['string', 'null'] },
    lastName: { type: ['string', 'null'] },
    roleId: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    datecreated: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    alertMetaData: { type: ['string', 'null'] },
  },
};
